import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'
import router from '@/router'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.request.use(
    config => {
        let accessToken = sessionStorage.getItem('accessToken')
        if (accessToken) {
            config.headers = Object.assign({
                Authorization: `Bearer ${accessToken}`
            }, config.headers);
        }
        return config;
    },
    error => {
        // return Promise.reject(error);
    })

    axios.interceptors.response.use(function (response) {
        // console.log(response,'interceptors')
      if(response.data.session_timeout){

        response.logout = true
        response.msg = 'Session Timeout'
        return Promise.reject(response)
        // this.$router.push('/pages/login').catch(() => {})
      }
      else{
        // response.logout = true
        // response.msg = 'Session Timeout'
        // return Promise.reject(response)
        
        return response
      }
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              console.log('fetchAccessToken',access_token)
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login (username, pwd) {
    
    return axios.post(`/auth/login`, {
      username,
      password: pwd
    })
    // return axios.post('/api/auth/login', {
    //   email,
    //   password: pwd
    // })
  },
  registerUser (name, email, pwd) {
    return axios.post('/api/auth/register', {
      displayName: name,
      email,
      password: pwd
    })
  },
  refreshToken () {
    return axios.post('/api/auth/refresh-token', {accessToken: sessionStorage.getItem('accessToKen')})
  }
}
